import basePath from "../path";

export default `${basePath}/linkedin/group`;
